/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ailoaderstepbuilding3Inputs */

const en_ailoaderstepbuilding3 = /** @type {(inputs: Ailoaderstepbuilding3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Building your result`)
};

const de_ailoaderstepbuilding3 = /** @type {(inputs: Ailoaderstepbuilding3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnis wird erstellt`)
};

/**
* | output |
* | --- |
* | "Building your result" |
*
* @param {Ailoaderstepbuilding3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ailoaderstepbuilding3 = /** @type {((inputs?: Ailoaderstepbuilding3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ailoaderstepbuilding3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ailoaderstepbuilding3(inputs)
	return de_ailoaderstepbuilding3(inputs)
});
export { ailoaderstepbuilding3 as "aiLoaderStepBuilding" }